import type { AppLanguage } from '../stores/language-store';

const translations = {
  ru: {
    // Sections Builder
    sectionsBuilder: 'Конструктор секций',
    sectionsBuilderHint: 'Выберите секции для генерации',
    sectionHeader: 'Хедер',
    sectionHero: 'Герой',
    sectionFeatures: 'Фичи',
    sectionCards: 'Карточки',
    sectionTestimonials: 'Отзывы',
    sectionPricing: 'Цены',
    sectionFaq: 'FAQ',
    sectionBottomNav: 'Нижняя навигация',
    sectionFooter: 'Футер',
    densityMinimal: 'Минимально',
    densityStandard: 'Стандартно',
    densityRich: 'Богато',
    densityLabel: 'Наполнение',
    clearSections: 'Очистить',
    // Prompt fragments (for AI prompt generation)
    promptSectionHeader: 'шапка сайта с логотипом и навигацией',
    promptSectionHero: 'герой-секция с заголовком, подзаголовком и кнопкой призыва к действию',
    promptSectionFeatures: 'секция с преимуществами/фичами (иконки и описания)',
    promptSectionCards: 'сетка карточек с изображениями и текстом',
    promptSectionTestimonials: 'секция отзывов клиентов',
    promptSectionPricing: 'секция с тарифами/ценами',
    promptSectionFaq: 'секция часто задаваемых вопросов',
    promptSectionBottomNav: 'нижняя навигационная панель',
    promptSectionFooter: 'подвал сайта с контактами и ссылками',
    promptDensityMinimal: 'минималистичный дизайн, много воздуха, мало элементов',
    promptDensityStandard: 'сбалансированный дизайн со стандартным количеством контента',
    promptDensityRich: 'насыщенный дизайн с большим количеством деталей и контента',
    // Mobile App Sections
    mobileSectionTabBar: 'Tab Bar',
    mobileSectionDrawer: 'Drawer Menu',
    mobileSectionSplash: 'Splash Screen',
    mobileSectionListFeed: 'List/Feed',
    mobileSectionDetail: 'Detail Screen',
    mobileSectionForm: 'Form',
    mobileSectionModal: 'Modal',
    mobileSectionLoading: 'Loading State',
    mobileSectionEmpty: 'Empty State',
    mobileSectionError: 'Error Screen',
    promptMobileSectionTabBar: 'нижняя навигация с иконками (tab bar)',
    promptMobileSectionDrawer: 'боковое меню/drawer навигация',
    promptMobileSectionSplash: 'splash/welcome экран при запуске',
    promptMobileSectionListFeed: 'список или feed с карточками элементов',
    promptMobileSectionDetail: 'детальный экран просмотра элемента',
    promptMobileSectionForm: 'форма для ввода/редактирования данных',
    promptMobileSectionModal: 'модальное окно или bottom sheet',
    promptMobileSectionLoading: 'состояние загрузки (skeleton, spinner)',
    promptMobileSectionEmpty: 'пустое состояние (нет данных)',
    promptMobileSectionError: 'экран ошибки с сообщением и кнопкой повтора',
    layoutType: 'Тип макета',
    // Prompt Preview
    previewPrompt: 'Предпросмотр промпта',
    previewTooltip: 'Показать финальный промпт, который будет отправлен AI',
    previewTitle: 'Финальный промпт для AI',
    copyPrompt: 'Копировать промпт',
    close: 'Закрыть',
    // General
    toggleSidebar: 'Свернуть/развернуть панели',
    switchToDesktop: 'Десктоп',
    switchToTablet: 'Планшет',
    switchToMobile: 'Мобильный',
    measureDistance: 'Измерение расстояний',
    saveProjectToStorage: 'Сохранить проект в Storage',
    save: 'Сохранить',
    version: 'Версия',
    saveVersionPrompt: 'Сохранить поверх текущей версии или создать новую?',
    overwrite: 'Перезаписать',
    newVersion: 'Новая',
    deleteVersionTitle: 'Удалить версию',
    deleteVersionPrompt: 'Удалить выбранную версию? Это действие нельзя отменить.',
    deleteVersion: 'Удалить',
    cannotDeleteLastVersion: 'Нельзя удалить последнюю версию.',
    versionComment: 'Комментарий к версии',
    versionCommentPlaceholder: 'Что изменилось в этой версии (опционально)...',
    viewComment: 'Комментарий',
    noComment: 'Комментария нет.',
    editComment: 'Изменить',
    saveComment: 'Сохранить',
    reference: 'Референс',
    referenceHelp: 'Выберите страницу (и при желании другую версию), чтобы добавить ее как референс в промпт.',
    referenceClear: 'Очистить',
    referenceApply: 'Применить',
    page: 'Страница',
    selectPage: 'Выберите страницу...',
    noPagesAvailable: 'Нет доступных страниц',
    loading: 'Загрузка...',
    copyHtml: 'Копировать HTML',
    copy: 'Копировать',
    copied: 'Скопировано',
    downloadHtml: 'Скачать HTML',
    download: 'Скачать',
    sendInfo: 'Отправить инфо',
    settings: 'Настройки',
    createProjectInPanel: 'Создайте проект в панели',
    canvasAfterProjectClick: 'Канвас появится после клика по проекту слева.',
    langRu: 'RU',
    langEn: 'EN',
  },
  en: {
    // Sections Builder
    sectionsBuilder: 'Sections Builder',
    sectionsBuilderHint: 'Select sections to generate',
    sectionHeader: 'Header',
    sectionHero: 'Hero',
    sectionFeatures: 'Features',
    sectionCards: 'Cards',
    sectionTestimonials: 'Testimonials',
    sectionPricing: 'Pricing',
    sectionFaq: 'FAQ',
    sectionBottomNav: 'Bottom Nav',
    sectionFooter: 'Footer',
    densityMinimal: 'Minimal',
    densityStandard: 'Standard',
    densityRich: 'Rich',
    densityLabel: 'Density',
    clearSections: 'Clear',
    // Prompt fragments (for AI prompt generation)
    promptSectionHeader: 'header with logo and navigation',
    promptSectionHero: 'hero section with headline, subheadline and call-to-action button',
    promptSectionFeatures: 'features section with icons and descriptions',
    promptSectionCards: 'cards grid with images and text',
    promptSectionTestimonials: 'customer testimonials section',
    promptSectionPricing: 'pricing plans section',
    promptSectionFaq: 'frequently asked questions section',
    promptSectionBottomNav: 'bottom navigation bar',
    promptSectionFooter: 'footer with contacts and links',
    promptDensityMinimal: 'minimalist design with lots of whitespace, few elements',
    promptDensityStandard: 'balanced design with standard amount of content',
    promptDensityRich: 'rich design with many details and content',
    // Mobile App Sections
    mobileSectionTabBar: 'Tab Bar',
    mobileSectionDrawer: 'Drawer Menu',
    mobileSectionSplash: 'Splash Screen',
    mobileSectionListFeed: 'List/Feed',
    mobileSectionDetail: 'Detail Screen',
    mobileSectionForm: 'Form',
    mobileSectionModal: 'Modal',
    mobileSectionLoading: 'Loading State',
    mobileSectionEmpty: 'Empty State',
    mobileSectionError: 'Error Screen',
    promptMobileSectionTabBar: 'bottom navigation with icons (tab bar)',
    promptMobileSectionDrawer: 'side menu/drawer navigation',
    promptMobileSectionSplash: 'splash/welcome screen on app launch',
    promptMobileSectionListFeed: 'list or feed with item cards',
    promptMobileSectionDetail: 'detail screen for viewing item details',
    promptMobileSectionForm: 'form for data input/editing',
    promptMobileSectionModal: 'modal window or bottom sheet',
    promptMobileSectionLoading: 'loading state (skeleton, spinner)',
    promptMobileSectionEmpty: 'empty state (no data)',
    promptMobileSectionError: 'error screen with message and retry button',
    layoutType: 'Layout Type',
    // Prompt Preview
    previewPrompt: 'Preview prompt',
    previewTooltip: 'Show the final prompt that will be sent to AI',
    previewTitle: 'Final prompt for AI',
    copyPrompt: 'Copy prompt',
    close: 'Close',
    // General
    toggleSidebar: 'Toggle panels',
    switchToDesktop: 'Desktop',
    switchToTablet: 'Tablet',
    switchToMobile: 'Mobile',
    measureDistance: 'Measure distances',
    saveProjectToStorage: 'Save project to Storage',
    save: 'Save',
    version: 'Version',
    saveVersionPrompt: 'Overwrite the current version or create a new one?',
    overwrite: 'Overwrite',
    newVersion: 'New',
    deleteVersionTitle: 'Delete version',
    deleteVersionPrompt: 'Delete the selected version? This action cannot be undone.',
    deleteVersion: 'Delete',
    cannotDeleteLastVersion: 'You cannot delete the last version.',
    versionComment: 'Version comment',
    versionCommentPlaceholder: 'What changed in this version (optional)...',
    viewComment: 'Comment',
    noComment: 'No comment.',
    editComment: 'Edit',
    saveComment: 'Save',
    reference: 'Reference',
    referenceHelp: 'Choose a page (and optionally a different version) to use as a reference. It will be appended to the prompt.',
    referenceClear: 'Clear',
    referenceApply: 'Apply',
    page: 'Page',
    selectPage: 'Select page...',
    noPagesAvailable: 'No pages available',
    loading: 'Loading...',
    copyHtml: 'Copy HTML',
    copy: 'Copy',
    copied: 'Copied',
    downloadHtml: 'Download HTML',
    download: 'Download',
    sendInfo: 'Send info',
    settings: 'Settings',
    createProjectInPanel: 'Create a project in the panel',
    canvasAfterProjectClick: 'The canvas will appear after clicking a project on the left.',
    langRu: 'RU',
    langEn: 'EN',
  },
} as const;

export type TranslationKey = keyof (typeof translations)['ru'];

export function t(language: AppLanguage, key: TranslationKey): string {
  return translations[language][key];
}
